<h2 i18n><span>C</span>ontacto</h2>
<div id="contact_container" class="{{language}}" [ngSwitch]="currentState">
    <form [formGroup]="contactForm" *ngSwitchCase="ComponentState.Form">
        <!-- Nombre -->
        <div appearance="outline" class="input_container"
            [ngClass]="{'error': contactForm.get('name')?.invalid && (contactForm.get('name')?.dirty || contactForm.get('name')?.touched)}">
            <label i18n for="name">Nombre</label>
            <input matInput formControlName="name" placeholder="-" autocomplete="name" id="name">
            <div i18n id="name_error" class="input_error"
                *ngIf="contactForm.get('name')?.invalid && (contactForm.get('name')?.dirty || contactForm.get('name')?.touched)">
                Ingresa tu nombre.
            </div>
        </div>

        <!-- Correo Electrónico -->
        <div appearance="outline" class="input_container email_input"
            [ngClass]="{'error': contactForm.get('email')?.invalid && (contactForm.get('email')?.dirty || contactForm.get('email')?.touched)}">
            <label i18n for="email">Correo Electrónico</label>
            <input matInput type="email" formControlName="email" placeholder="-" autocomplete="email" id="email">
            <div i18n id="email_error" class="input_error"
                *ngIf="contactForm.get('email')?.invalid && (contactForm.get('email')?.dirty || contactForm.get('email')?.touched)">
                Introduce una dirección de correo electrónico válida.
            </div>
        </div>

        <!-- Consulta -->
        <div appearance="outline" class="input_container"
            [ngClass]="{'error': contactForm.get('description')?.invalid && (contactForm.get('description')?.dirty || contactForm.get('description')?.touched)}">
            <label i18n for="description">Consulta</label>
            <textarea matInput formControlName="description" placeholder="-" autocomplete="off"
                id="description"></textarea>
            <div i18n id="description_error" class="input_error"
                *ngIf="contactForm.get('description')?.invalid && (contactForm.get('description')?.dirty || contactForm.get('description')?.touched)">
                Escribe tu consulta.
            </div>
        </div>

        <div appearance="outline" class="input_container" id="terms"
            [ngClass]="{'error': contactForm.get('terms')?.invalid && (contactForm.get('terms')?.dirty || contactForm.get('terms')?.touched)}">

            <input type="checkbox" formControlName="terms" id="check_terms" name="terms">

            <label for="check_terms" i18n="@@termslink">
                Acepto los
                <span (click)="showTermsAndConditions()" (keyup.enter)="showTermsAndConditions()" tabindex="0">
                    términos y condiciones
                </span>
                y la
                <span (click)="showPrivacyPolicy()" (keyup.enter)="showPrivacyPolicy()" tabindex="0">
                    política de privacidad
                </span>
            </label>

        </div>

        <!-- Botón Enviar -->
        <div class="form_button" (click)="submitForm()" (keyup.enter)="submitForm()" tabindex="0" i18n>Enviar</div>
    </form>

    <!-- Cargando Spinner -->
    <div id="progress_mail" *ngSwitchCase="ComponentState.Loading">
        <mat-spinner></mat-spinner>
    </div>

    <!-- Mensaje Enviado -->
    <div id="sended_mail" *ngSwitchCase="ComponentState.Success">
        <img src="assets/images/check.webp" alt="verificado" i18n-alt />
        <p i18n>Correo enviado</p>
    </div>

    <!-- Mensaje de Error al Enviar -->
    <div id="error_send_mail" *ngSwitchCase="ComponentState.Error">
        <img src="assets/images/error_mail.webp" alt="Icono de error" i18n-alt />
        <p i18n>Lo sentimos, tu mensaje no pudo ser enviado. Por favor, intenta nuevamente más tarde.</p>
    </div>
</div>